import React from 'react';
import Layout from 'components/layout';
import colors from 'shared-components/theme/colors';
import GoesNavbar from '../components/geos-navbar';
import GeoBanner from '../components/geo-banner';
import { baseURL } from 'shared-components/theme/helpers';
import IntroStatisitcs from '../components/intro-stats';
import Talent from '../components/talent';
import Global from '../components/global';
import Tech from '../components/tech';
import Results from '../components/results';
import LetsBuild from '../components/lets-build';

const GoesPakistan = () => {
    return (
        <Layout bgColor={colors.gray_lighter['100']} page={'pakistan'}>
            <GoesNavbar />
            <GeoBanner
                bannerTextUrl={`${baseURL}assets/images/geos/pakistan/pk-text.svg`}
                bgOne={`${baseURL}assets/images/geos/pakistan/banner-bg-1.webp`}
                bgTwo={`${baseURL}assets/images/geos/pakistan/banner-bg-2.webp`}
                bgThree={`${baseURL}assets/images/geos/pakistan/banner-bg-3.webp`}
                tagline={'Where outsourcing meets opportunity.'}
            />
            <IntroStatisitcs />
            <Talent />
            <Tech />
            <Global
                bgImg={`${baseURL}assets/images/geos/pakistan/global.jpg`}
            />
            <Results />
            <LetsBuild
                text={'Let’s build your team in Pakistan'}
                btnTxt={'Start now'}
                btnColor={colors.geoGreen[100]}
                href={"/contact-us"}
            />
        </Layout>
    );
};

export default GoesPakistan;
